/** @jsx jsx */
import { jsx } from '@compiled/react';
import { Text } from '@atlaskit/primitives/compiled/text';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { EmptyContentMenuItem } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/ui/empty-content/index.tsx';

const emptyProjectsMessage = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.empty-content.empty-projects-message',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: "Once you visit or create projects, they'll show up here.",
	description: "Message shown to user when they don't have any projects",
});

const emptyProjectsMessageGalaxiaMessage = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.empty-content.empty-projects-message-galaxia',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: "Once you visit or create spaces, they'll show up here.",
	description: "Message shown to user when they don't have any projects",
});

export function Nav4ProjectsEmptyContent(): JSX.Element {
	const emptyProjectsMessageGalaxia = expVal('project-terminology-refresh', 'isEnabled', false)
		? emptyProjectsMessageGalaxiaMessage
		: emptyProjectsMessage;
	const { formatMessage } = useIntl();

	return (
		<EmptyContentMenuItem>
			<Text size="small" color="color.text.subtle">
				{formatMessage(emptyProjectsMessageGalaxia)}
			</Text>
		</EmptyContentMenuItem>
	);
}
